import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import {
  baseURL,
  javaBaseURL,
  oldBaseURL,
  SECRET_KEY,
  apiMock,
  mockBaseURL
} from '@/config'
import { Toast } from 'vant'
import { CommonModule } from '@/store/modules/common'
import qs from 'qs'
import md5 from 'js-md5'
import { aesEncrypt, getAppLanguage, getPlatform } from '@/common/utils'
import { isIOS, aseDecryptApi } from '@/common/utils'
import { callAppFunc_checkVersion } from '@/common/utils/bridge'
export function stringifyData(config: any) {
  config.data = qs.stringify(config.data)
  return config
}
const language = getAppLanguage()
const platform = getPlatform()
export function _log(response: AxiosResponse<any>) {
  if (process.env.NODE_ENV === 'development') {
    console.group()
    console.log('*==== 请求信息 ====*')
    console.log('地址：', response.config.method, response.config.url)
    const data = response.config.data
    const params = response.config.params

    if (data && JSON.stringify(data) != '"{}"') {
      Object.keys(data).length > 0 && console.log('请求参数：', data)
    }
    if (params && JSON.stringify(params) != '"{}"') {
      Object.keys(params).length > 0 && console.log('QUERY参数：', params)
    }
    console.log('响应结果：', response.data)
    console.log('响应配置：', response.config)
    console.log('-------------------------------------------')
    console.groupEnd()
  }
}

export function addSign(config: any) {
  const timestamp = Math.floor(new Date().getTime() / 1000)

  config.headers['timestamp'] = timestamp
  //config.headers['sign'] = sign
  config.headers['app-version'] = CommonModule.appVersion
  config.headers['device-id'] = CommonModule.deviceId
  config.headers['request-from'] = CommonModule.requestFrom
  if (!config.headers['app-front']) {
    config.headers['app-front'] = 1
  }
  config.headers['channel'] = CommonModule.channel
  //config.headers['platform'] = isIOS ? 'ios' : 'android'
  const encryp = aesEncrypt(
    config.data ? config.data : config.params ? config.params : {}
  )
  config.headers['sign'] = encryp.toString()
  config.headers['language'] = language == 'uyghur' ? 'ug' : 'cn'
  return config
}
export function addJavaSign(config: any) {
  const timestamp = Math.floor(new Date().getTime() / 1000)

  config.headers['timestamp'] = timestamp
  //config.headers['sign'] = sign
  config.headers['app-version'] = CommonModule.appVersion
  config.headers['device-id'] = CommonModule.deviceId
  config.headers['request-from'] = CommonModule.requestFrom
  if (!config.headers['app-front']) {
    config.headers['app-front'] = 1
  }
  config.headers['channel'] = CommonModule.channel

  config.headers['platform'] = config.headers['platform']
    ? config.headers['platform']
    : isIOS
    ? 'ios'
    : 'android'
  const encryp = aesEncrypt(
    config.data ? config.data : config.params ? config.params : {}
  )
  config.headers['sign'] = encryp.toString()
  config.headers['language'] = language == 'uyghur' ? 'ug' : 'cn'
  return config
}

export function serviceFulfilled(response: AxiosResponse) {
  // _log(response)
  // 对响应数据做点什么

  const data = response.data as any
  if (response.status === 200) {
    if (data.code == '200') {
      if (data.encryptMode == 1) {
        const tmp = Object.assign({}, data)
        tmp.data = aseDecryptApi(data.data)
        return tmp
      }
      return response.data
    } else if (data.code == '100003') {
      Toast(data.msg)
      CommonModule.localLoginOut()
      if (platform != 'kigo') {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = 'https://h5test.wlwyl.com'
        } else {
          window.location.href = 'https://h5.wlwyl.com'
        }
      }
    } else if (data.code == '6001') {
      console.log('code 6001')
      callAppFunc_checkVersion(data.data)
    } else if (
      data.code == '210020' ||
      data.code == '210026' ||
      data.code == '210027' ||
      data.code == '210028' ||
      data.code == '210030'
    ) {
      return response.data
    } else if (data.code && data.code != '1001') {
      Toast(data.msg || '服务器异常')
    }
    if (!data.code) {
      return response.data
    }
    return Promise.reject(data)
  } else {
    return Promise.reject(response)
  }
}

export function serviceRejected(error: Error) {
  // 对响应错误做点什么
  console.error(error)
  const errText =
    language == 'zh_CN' ? '网络请求失败，请重试' : 'tor ulanmidi， kayta sinag'
  error.message &&
    Toast(error.message == 'Network Error' ? errText : error.message)
  return Promise.reject(error)
}

const service = axios.create({
  baseURL,
  timeout: 100000
})
service.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
const phpServiceNoToast = axios.create({
  baseURL,
  timeout: 100000
})
phpServiceNoToast.defaults.headers['Content-Type'] =
  'application/x-www-form-urlencoded'
function addAuthorization(config: any) {
  const Authorization = CommonModule.token
  if (Authorization) {
    config.headers['Authorization'] = Authorization
  }
  if (config.params && config.params.removeToken) {
    delete config.params.removeToken
    delete config.headers['Authorization']
  }
  //Authorization && (config.headers['Authorization'] = Authorization)
  config.headers['flavors'] = CommonModule.flavors
  config.headers['package-name'] = CommonModule.packageName
  return config
}

export function useMock(config: any) {
  if (apiMock) {
    config.baseURL = mockBaseURL
  }
  return config
}
export function serviceFulfilledNoToast(response: AxiosResponse) {
  // _log(response)
  // 对响应数据做点什么

  if (response.status === 200) {
    return response.data
  } else {
    return Promise.reject(response)
  }
}
service.interceptors.request.use(addAuthorization)
service.interceptors.request.use(addSign)
service.interceptors.request.use(useMock)
service.interceptors.response.use(serviceFulfilled, serviceRejected)
phpServiceNoToast.interceptors.request.use(addAuthorization)
phpServiceNoToast.interceptors.request.use(addSign)
phpServiceNoToast.interceptors.request.use(useMock)
phpServiceNoToast.interceptors.response.use(
  serviceFulfilledNoToast,
  serviceRejected
)
export { service, phpServiceNoToast }

export const javaService = axios.create({
  baseURL: javaBaseURL,
  timeout: 60 * 1000
})
javaService.interceptors.request.use(addJavaSign)
javaService.interceptors.request.use(addAuthorization)
javaService.interceptors.response.use(serviceFulfilled, serviceRejected)
